const { default: Axios } = require('axios');

/**
 * Carga un evento sobre los elementos seleccionados 
 * 
 * @param {type}       type             El tipo de evento. Ej: 'click' 
 * @param {NodeList[]} el               Los elementos seleccionados. Ej: '.info'
 * @param {Function}   listener         La función "listener" a ejecutar
 * 
 */
const on = (type, el, listener) => {
    let selectEl = [...document.querySelectorAll(el)];
    selectEl.forEach(event => event.addEventListener(type, listener));
};

/**
 * Modal de información sobre un grado de una escala de dificultad
 * 
 */
on('click', '.info-scale', function (event) {
    event.preventDefault();
    
    // Obtiene la escala de dificultad y el grado
    const scale = event.currentTarget.dataset.scale;
    const grade = event.currentTarget.dataset.grade;

    // Muestra el loader
    waiting.show();

    // Obtiene el contenido de la modal que muestra información sobre un grado de dificultad
    Axios.post(`/com/mount/info/scale/${scale}`, {
        grade : grade,
    }).then(response => {
        // Oculta el loader
        waiting.hide();

        // Selecciona la modal de información del grado de dificultad, cargando su contenido
        const modal = document.getElementById('modal-info-difficult-scale');

        modal.querySelector('.content').innerHTML = response.data;

        // Abre la modal
        new bootstrap.Modal( modal).show();
    }).catch(error => {
        // Oculta el loader
        waiting.hide();

        console.error(error);
    });
});

/**
 * Modal de información sobre un itinerario de gran recorrido (GR)
 * 
 */
on('click', '.info-path', function (event) {
    event.preventDefault();
    
    // Obtiene el id o numeración del sendero de GR
    // El id es el número del GR (por ejemplo, pata el GR90.1, el id será 90.1)
    const id = event.currentTarget.dataset.id;

    // Muestra el loader
    waiting.show();

    // Obtiene el contenido de la modal que muestra información sobre un sendero de GR
    Axios.post(`/com/mount/info/path/${id}`) 
    .then(response => {
        // Oculta el loader
        waiting.hide();

        // Selecciona la modal de información del grado de dificultad, cargando su contenido
        const modal = document.getElementById('modal-info-foot-path');

        modal.querySelector('.content').innerHTML = response.data;

        // Abre la modal
        new bootstrap.Modal( modal).show();
    }).catch(error => {
        // Oculta el loader
        waiting.hide();

        console.error(error);
    });
});
